import {BaseModel} from "../../base/models/base-model.model";
import {RoleProcessToModel} from "./role-process-to.model";

export class ProcessToModel extends BaseModel {
  private _name?: string;
  private _roles?: Array<RoleProcessToModel>;

  constructor(name?: string, roles?: Array<RoleProcessToModel>) {
    super();
    this._name = name;
    this._roles = roles;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get roles(): Array<RoleProcessToModel> {
    return this._roles;
  }

  set roles(value: Array<RoleProcessToModel>) {
    this._roles = value;
  }
}
